import { render, staticRenderFns } from "./CartsListItem.vue?vue&type=template&id=56008833&scoped=true"
import script from "./CartsListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./CartsListItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./CartsListItem.vue?vue&type=style&index=0&id=56008833&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56008833",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CLtkImg: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CLtkImg/CLtkImg.vue').default,CIcon: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CIcon/CIcon.vue').default,CBtn: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CBtn/CBtn.vue').default,CCard: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/vuetify-components/CCard/CCard.vue').default,CBtnPrimary: require('/opt/rewardStyle/src/github.com/rewardStyle/ltk-vue/node_modules/@rscollabs/capsule-wardrobe-components/src/components/CBtnPrimary/CBtnPrimary.vue').default})
